import { render, staticRenderFns } from "./NovaConversa.vue?vue&type=template&id=296a2b68"
import script from "./NovaConversa.vue?vue&type=script&lang=js"
export * from "./NovaConversa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports